import config from '../config/config';

// ฟังก์ชันสำหรับดึง token จาก localStorage
const getAuthToken = () => {
  return localStorage.getItem('token');
};

// ฟังก์ชันสำหรับสร้าง headers พร้อม token
const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

// ดึงประวัติแชททั้งหมดของผู้ใช้
export const fetchChatHistory = async () => {
  try {
    const response = await fetch(`${config.API_BASE_URL}/chat/history`, {
      method: 'GET',
      headers: getAuthHeaders()
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching chat history:', error);
    throw error;
  }
};

// ดึงประวัติแชทของ session หนึ่ง
export const fetchChatSession = async (sessionId) => {
  try {
    const response = await fetch(`${config.API_BASE_URL}/chat/history/${sessionId}`, {
      method: 'GET',
      headers: getAuthHeaders()
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching chat session:', error);
    throw error;
  }
};

// บันทึกข้อความใหม่
export const saveChatMessage = async (sessionId, message, tripDetails = null) => {
  try {
    const response = await fetch(`${config.API_BASE_URL}/chat/save`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        sessionId,
        message,
        tripDetails
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error saving chat message:', error);
    throw error;
  }
};

// อัปเดตประวัติแชท
export const updateChatHistory = async (sessionId, messages, tripDetails = null) => {
  try {
    const response = await fetch(`${config.API_BASE_URL}/chat/history/${sessionId}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        messages,
        tripDetails
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error updating chat history:', error);
    throw error;
  }
};

// ลบประวัติแชท
export const deleteChatHistory = async (sessionId) => {
  try {
    const response = await fetch(`${config.API_BASE_URL}/chat/history/${sessionId}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error deleting chat history:', error);
    throw error;
  }
};

// ดึงรายการ session ทั้งหมด
export const fetchChatSessions = async () => {
  try {
    const response = await fetch(`${config.API_BASE_URL}/chat/sessions`, {
      method: 'GET',
      headers: getAuthHeaders()
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching chat sessions:', error);
    throw error;
  }
}; 